import { css } from 'emotion';

import { colors } from '../styles';

export const option = css`
  margin-left: 12px;
  width: 80%;

  > div {
    margin: 8px 0 0 0;
  }
`;

export const baseSelect = css`
  color: ${colors.primary.default};
  border: 1px solid hsl(0, 0%, 80%);
  border-radius: 4px;

  /* optional option icon */
  & > svg {
    width: 19px;
    height: 19px;

    && {
      font-size: 19px;
    }
  }
`;
